import { render, staticRenderFns } from "./newIntentionCom.vue?vue&type=template&id=7348eb2e&"
import script from "./newIntentionCom.vue?vue&type=script&lang=js&"
export * from "./newIntentionCom.vue?vue&type=script&lang=js&"
import style0 from "./newIntentionCom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports